import { typedQueryClient, useTypedQuery } from "hooks";
import { ExactFailuresQueryKeys } from "modules/ExactMonitoring/queryKeys";
import { EXACT_MONITORING_STORAGE_KEYS } from "modules/ExactMonitoring/storageKeys";
import { getPreference, setPreference } from "utils/common";
import { toDate } from "utils/dateHelperFunctions";

import type { ExactFailuresFilters } from "modules/ExactMonitoring/queryKeys";

const getInitialExactMonitoringFilters = (): ExactFailuresFilters => {
  const storedDateFrom = getPreference<Date | null>(EXACT_MONITORING_STORAGE_KEYS.DateFromPreference, null);
  const storedDateTo = getPreference<Date | null>(EXACT_MONITORING_STORAGE_KEYS.DateToPreference, null);

  return {
    action: getPreference(EXACT_MONITORING_STORAGE_KEYS.ActionPreference, null),
    status_code: getPreference(EXACT_MONITORING_STORAGE_KEYS.StatusCodePreference, null),
    date_from: storedDateFrom ? toDate(storedDateFrom) : null,
    date_to: storedDateTo ? toDate(storedDateTo) : null,
    page: 1
  };
};

const persistExactMonitoringFilters = (filters: ExactFailuresFilters) => {
  setPreference(EXACT_MONITORING_STORAGE_KEYS.ActionPreference, filters.action);
  setPreference(EXACT_MONITORING_STORAGE_KEYS.StatusCodePreference, filters.status_code);
  setPreference(EXACT_MONITORING_STORAGE_KEYS.DateFromPreference, filters.date_from);
  setPreference(EXACT_MONITORING_STORAGE_KEYS.DateToPreference, filters.date_to);
};

export const useExactMonitoringFilters = () => useTypedQuery({ queryKey: ExactFailuresQueryKeys.failuresFilters, initialData: getInitialExactMonitoringFilters }).data;

export const setExactMonitoringFilters = (updatedFilters: ExactFailuresFilters) => {
  persistExactMonitoringFilters(updatedFilters);

  typedQueryClient.setQueryData(ExactFailuresQueryKeys.failuresFilters, { ...updatedFilters });
};

export const setExactMonitoringStatusCodeFilter = (status_code: number | null) => {
  setPreference(EXACT_MONITORING_STORAGE_KEYS.StatusCodePreference, status_code);

  typedQueryClient.setQueryData(ExactFailuresQueryKeys.failuresFilters, prev => (prev ? { ...prev, status_code, page: 1 } : prev));
};
